import { getAuthData } from 'modules/Auth/request-auth-data';
import { Tenants } from 'modules/Subscriptions/models';

function useIsAplifisa() {
  const { tenant } = getAuthData();
  return tenant === Tenants.TSAPLIFISA;
}

export default useIsAplifisa;
